import { render, staticRenderFns } from "./PBottomSlideModal.vue?vue&type=template&id=5d766c0a&scoped=true&"
import script from "./PBottomSlideModal.vue?vue&type=script&lang=ts&"
export * from "./PBottomSlideModal.vue?vue&type=script&lang=ts&"
import style0 from "./PBottomSlideModal.vue?vue&type=style&index=0&id=5d766c0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d766c0a",
  null
  
)

export default component.exports